"use client";

interface ToggleSwitchProps {
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
    activeColor?: string;
    "aria-label": string;
}

/**
 * A reusable toggle switch component with customizable active color.
 * Renders as an accessible `role="switch"` button.
 */
export function ToggleSwitch({
    checked,
    onChange,
    disabled = false,
    activeColor = "bg-primary",
    "aria-label": ariaLabel,
}: ToggleSwitchProps) {
    return (
        <button
            type="button"
            onClick={onChange}
            disabled={disabled}
            className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 disabled:cursor-not-allowed disabled:opacity-50 ${
                checked ? activeColor : "bg-slate-300 dark:bg-slate-600"
            }`}
            role="switch"
            aria-checked={checked}
            aria-label={ariaLabel}
        >
            <span
                className={`pointer-events-none inline-block size-4 rounded-full bg-white shadow-sm ring-0 transition-transform duration-200 ${
                    checked ? "translate-x-[22px]" : "translate-x-[2px]"
                }`}
            />
        </button>
    );
}
